























































































































































































































import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import moment from 'moment';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { Funcionalidades } from '@/config/funcionalidades';

import { fetchMS } from '../fetchMS';

@Component({
  components: {
    DatePicker,
    FormFieldsContainer,
  },
})
export default class ModalEditSeriado extends Vue {
  @Prop({ required: true, default: {} }) data!: {
    asignumero?: string;
    epc?: string;
    estado_inventario?: string;
    estado_preparacion?: string;
    fecha_bateria?: moment.Moment | string;
    id?: string;
    modalidad?: string;
    plataforma?: string;
    sereactivainet_flagok?: string;
    serieactivaavl?: string;
    serieactivafecha_alta?: moment.Moment | string;
    serieactivaid_dispositivo?: string;
    serieactivainet_movimientonro?: string;
    serieactivamodalidad?: string;
    serieactivanro?: string;
    serieactivaobs?: string;
    serieactivaplata_fecha?: moment.Moment | string;
    serieactivaplata_ingresada?: string;
    serieactivaplataforma?: string;
    serienumero?: string;
    simserienumero?: string;
    tipoeq?: string;
    tipoeqid?: string;
    serieactiva_novalido?: string;
    serieactiva_finalizada?: string;
  };
  @Prop({ required: true, default: false }) isEdit!: boolean;
  @Prop({ required: true, default: false }) deshabilitar!: boolean;
  @Prop({ required: true, default: null }) funcionalidad!: Funcionalidades;

  // Variables Globales
  loading: boolean = false;
  disabledForm: boolean = true;
  contErrors: number = 0;
  deviceList: string[] = [];
  modalityList: string[] = [];
  avlList: string[] = [];
  disabledFiled: Record<string, boolean> = {
    deviceList: true,
    plataformDate: true,
    btnSave: false,
    bateria: true,
  };
  objParam: {
    asignumero?: string;
    epc?: string;
    estado_inventario?: string;
    estado_preparacion?: string;
    fecha_bateria?: moment.Moment | string;
    id?: string;
    modalidad?: string;
    plataforma?: string;
    sereactivainet_flagok?: string;
    serieactivaavl?: string;
    serieactivafecha_alta?: moment.Moment | string;
    serieactivaid_dispositivo?: string;
    serieactivainet_movimientonro?: string;
    serieactivamodalidad?: string | any;
    serieactivanro?: string;
    serieactivaobs?: string;
    serieactivaplata_fecha?: moment.Moment | string;
    serieactivaplata_ingresada?: string;
    serieactivaplataforma?: string | any;
    serienumero?: string;
    simserienumero?: string;
    tipoeq?: string;
    tipoeqid?: string | any;
    bateria?: boolean;
    plataforma_ingresada?: boolean;
    estado?: string;
    validauser?: boolean;
    serieactiva_novalido?: string;
    simmovil?: string;
    telconame?: string;
    serieimei?: string;
  } = {};

  // Variables de Solo Lectura
  readonly loadingService: LoadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  async mounted() {
    try {
      this.loading = true;
      await Promise.all([
        this.initialFieldValues(),
        this.getModalidad(),
        this.getTipoEquipos(),
        this.getAVL(),
        this.getEstadoSim(),
      ]);
    } catch (err) {
      console.error('Error:', err);
    } finally {
      this.loading = false;
    }
  }

  // Validacion de los valores en los inputs
  rules = {
    counter: (val: any) =>
      !!val && val.length > 350
        ? this.ruleValue('Solo se permite un máximo de 350 caracteres')
        : this.ruleValue(),
    serie: (val: any) =>
      !val || !val.trim()
        ? this.ruleValue('El campo Serie Número es un campo obligatorio')
        : this.ruleValue(),
    equipo: (val: any) =>
      !val && !this.disabledFiled.deviceList
        ? this.ruleValue('El campo Tipo Equipo es un campo obligatorio')
        : this.ruleValue(),
  };

  ruleValue(msg: string = '') {
    if (msg) {
      this.contErrors++;
      this.disabledFiled.btnSave = true;
      return `${msg}`;
    }
    this.contErrors !== 0 && this.contErrors--;
    if (this.contErrors === 0) {
      this.disabledFiled.btnSave = false;
    }
    return true;
  }

  initialFieldValues() {
    this.disabledFiled.deviceList = this.data.serienumero ? false : true;
    this.disabledForm = this.isEdit ? false : true;
    this.objParam = JSON.parse(JSON.stringify(this.data));

    // Poner la fecha inicial por defecto para la preparación
    this.objParam.serieactivafecha_alta = this.data.serieactivafecha_alta
      ? moment(this.data.serieactivafecha_alta)
      : moment();

    if (this.objParam.fecha_bateria) {
      const formatDate = moment(this.objParam.fecha_bateria);
      this.objParam.fecha_bateria = formatDate;
    }
    if (this.objParam.serieactivaplata_fecha) {
      const formatDate = moment(this.objParam.serieactivaplata_fecha);
      this.objParam.serieactivaplata_fecha = formatDate;
    }

    this.objParam.plataforma_ingresada =
      this.isEdit && this.objParam.serieactivaplata_fecha ? true : false;
    this.handleFechaPlataforma();

    this.objParam.bateria =
      this.isEdit && this.objParam.fecha_bateria ? true : false;
    this.handleBateriaSelected();

    this.objParam.validauser =
      this.data.estado_preparacion === 't' ? true : false;

    // Inhabilitamos el formulario si los campos serieactiva_novalido o serieactiva_finalizada son true
    if (
      this.data.serieactiva_novalido === 't' ||
      this.data.serieactiva_finalizada === 'Finalizado'
    ) {
      this.disabledForm = true;
    }
  }

  // Validación para cuando el campo serie número esté vacío
  @Watch('objParam.serienumero')
  handleSerieField() {
    if (!this.objParam.serienumero) {
      this.objParam.tipoeqid = '';
      this.disabledFiled.deviceList = true;
      this.disabledForm = true;
    }
  }

  @Watch('objParam.tipoeqid')
  handleDeviceFiled() {
    if (this.isEdit && !this.loading && !this.objParam.tipoeqid) {
      this.disabledForm = true;
    }
  }

  @Watch('objParam.simserienumero')
  handleEstadoSimSerieField() {
    if (this.isEdit) {
      const simserienumero: string = this.objParam.simserienumero
        ? this.objParam.simserienumero.trim()
        : '';

      if (!simserienumero) {
        this.objParam.estado = '';
        this.objParam.simmovil = '';
        this.objParam.telconame = '';
      }
    }
  }

  getTipoEquipos() {
    this.objParam.tipoeqid = '';
    this.disabledFiled.deviceList = true;
    const serienumero: string = this.objParam.serienumero
      ? this.objParam.serienumero.trim()
      : '';
    !!serienumero && this.cargarTiposEquipos();
  }

  async cargarTiposEquipos() {
    try {
      this.loadingService.showLoading(undefined, 'cargarTiposEquipos');
      const result = await fetchMS(
        { serienumero: this.objParam.serienumero },
        'getEquipos'
      );
      const {
        CODIGO_RESPUESTA,
        MENSAJE_RESPUESTA,
        data: DEVICE_LIST,
      } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.disabledFiled.deviceList = true;
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.disabledFiled.deviceList = !!this.isEdit;
      this.deviceList = DEVICE_LIST;
      if (this.isEdit && this.deviceList.length > 0) {
        let equipos: any = undefined;
        if (this.data.tipoeqid) {
          equipos = this.deviceList.find(
            (equipo: any) => this.data.tipoeqid === equipo.id
          );
        } else if (this.data.tipoeq) {
          equipos = this.deviceList.find(
            (equipo: any) => this.data.tipoeq === equipo.name
          );
        }
        if (equipos) {
          this.objParam.tipoeqid = equipos;
        }
      }
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error al finalizar Requerimiento, por favor intente nuevamente',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('cargarTiposEquipos');
    }
  }

  async handleTipoEquipoSelected() {
    if (this.objParam.serienumero && this.objParam.tipoeqid) {
      //this.cargarHistoricoBateria();
      this.disabledForm = false;
    }
  }
  async cargarHistoricoBateria() {
    if (
      this.isEdit &&
      'id' in this.objParam.tipoeqid &&
      this.objParam.tipoeqid.id === this.data.tipoeqid
    ) {
      this.cargarepc();
      return;
    }
    try {
      this.loadingService.showLoading(undefined, 'cargarHistoricoBateria');
      const result = await fetchMS(
        {
          serienumero: this.objParam.serienumero,
          equipo: this.objParam.tipoeqid,
          is_edit: this.isEdit,
          current_data: { ...this.data },
        },
        'get_cambio_bateria'
      );
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.disabledForm = true;
        throw new Error(MENSAJE_RESPUESTA);
      }
      if (!MENSAJE_RESPUESTA) {
        this.cargarepc();
        return;
      }
      this.cargarepc();
      this.objParam.fecha_bateria = moment(
        result.data.data[0].max,
        'YYYY-MM-DD HH:mm:ss'
      );
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error al finalizar Requerimiento, por favor intente nuevamente',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('cargarHistoricoBateria');
    }
  }

  async cargarepc() {
    if (!this.objParam.serienumero) return;
    try {
      this.disabledForm = false;
      const result = await fetchMS(
        { serienumero: this.objParam.serienumero },
        'epc'
      );
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.objParam.epc = result.data.data[0].epc;
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error al finalizar Requerimiento, por favor intente nuevamente',
        { timeout: 3000 }
      );
    }
  }

  async getModalidad() {
    try {
      this.loadingService.showLoading(undefined, 'getModalidad');
      const result = await fetchMS({}, 'get_modalidad');
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.modalityList = result.data.data;
      if (this.isEdit && this.modalityList.length > 0) {
        let modalidad: any = undefined;
        if (this.data.serieactivamodalidad) {
          modalidad = this.modalityList.find(
            (x: any) => this.data.serieactivamodalidad === x.id
          );
        } else if (this.data.modalidad) {
          modalidad = this.modalityList.find(
            (x: any) => this.data.modalidad === x.nombre
          );
        }
        if (modalidad) {
          this.objParam.serieactivamodalidad = modalidad;
        }
      }
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error al finalizar Requerimiento, por favor intente nuevamente',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('getModalidad');
    }
  }

  cargarModalidad() {
    this.loadingService.showLoading(undefined, 'cargarModalidad');
    let self = this;
    return fetchMS({}, 'get_modalidad')
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los AVL',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los AVL',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => self.loadingService.hideLoading('cargarModalidad'));
  }

  // Cerrar el Modal de las Series
  closeModal(reload: boolean) {
    this.$emit('closeModalSeriado', reload);
  }

  async getAVL() {
    try {
      this.loadingService.showLoading(undefined, 'getAVL');
      const result = await fetchMS({}, 'get_avl');
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.avlList = result.data.data;
      if (this.isEdit && this.avlList.length > 0) {
        let plataforma: any = undefined;
        if (this.data.serieactivaplataforma) {
          plataforma = this.avlList.find(
            (x: any) => this.data.serieactivaplataforma === x.id
          );
        } else if (this.data.plataforma) {
          plataforma = this.avlList.find(
            (x: any) => this.data.plataforma === x.numbre
          );
        }
        if (plataforma) {
          this.objParam.serieactivaplataforma = plataforma;
        }
      }
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error al finalizar Requerimiento, por favor intente nuevamente',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('getAVL');
    }
  }

  handleBateriaSelected() {
    if (this.objParam.bateria) {
      this.disabledFiled.bateria = false;
      this.objParam.fecha_bateria = this.objParam.fecha_bateria
        ? this.objParam.fecha_bateria
        : moment();
    } else {
      this.disabledFiled.bateria = true;
      this.objParam.fecha_bateria = '';
    }
  }

  async getEstadoSim() {
    const simserienumero: string = this.objParam.simserienumero
      ? this.objParam.simserienumero.trim()
      : '';
    if (!simserienumero || !this.isEdit || this.disabledForm) return;
    try {
      this.loadingService.showLoading(undefined, 'getEstadoSim');
      const result = await fetchMS(
        { simnumero: this.objParam.simserienumero },
        'get_simestado'
      );
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.objParam.estado = '';
        this.objParam.simmovil = '';
        this.objParam.telconame = '';

        // Forzar actualización del DOM
        this.$forceUpdate();

        if (!MENSAJE_RESPUESTA) return;
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.objParam.estado = result.data.data.estado;
      this.objParam.simmovil = result.data.data.simmovil;
      this.objParam.telconame = result.data.data.telconame;

      // Forzar actualización del DOM
      this.$forceUpdate();
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error al finalizar Requerimiento, por favor intente nuevamente',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('getEstadoSim');
    }
  }

  handleFechaPlataforma() {
    if (this.objParam.plataforma_ingresada) {
      this.disabledFiled.plataformDate = false;
      this.objParam.serieactivaplata_fecha = moment();
    } else {
      this.disabledFiled.plataformDate = true;
      this.objParam.serieactivaplata_fecha = '';
    }
  }

  handleEdit() {
    const serienumero: string = this.objParam.serienumero
      ? this.objParam.serienumero.trim()
      : '';

    if ((!this.isEdit && !this.objParam.tipoeqid) || !serienumero) {
      this.$snotify.error(
        'Debe completar todos los campos que están marcados como obligatorios'
      );
      return;
    }

    if (this.data.serieactiva_novalido === 't') {
      this.$snotify.error('El equipo ha sido devuelto anteriormente');
      return;
    }

    if (this.data.serieactiva_finalizada === 't') {
      this.$snotify.error('La serie ya se encuentra finalizada');
      return;
    }
    this.edit();
  }

  async edit() {
    try {
      this.loadingService.showLoading(undefined, 'agregarSeriado');
      const id_usuario: string = JSON.parse(window.localStorage.user).id;
      const id_editar: string = this.objParam.id || '';
      const modulo: Funcionalidades = this.funcionalidad;
      const endpoint: string = this.isEdit ? 'editarSeriado' : 'agregarSeriado';
      const body = {
        id_usuario,
        id_editar,
        modulo,
        current_data: { ...this.data },
        ...this.objParam,
      };

      const result = await fetchMS(body, `${endpoint}`);
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.$snotify.success(MENSAJE_RESPUESTA);
      this.closeModal(true);
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error al finalizar Requerimiento, por favor intente nuevamente',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('agregarSeriado');
    }
  }
}
